// hooks/useGTM.js
import { useEffect } from "react";

export function useGTM(gtmId, default_data = {}) {
  useEffect(() => {
    if (!gtmId || !default_data?.Unique_ID || window.gtmDidInit) return;
    window.gtmDidInit = true;

    window.dataLayer = window.dataLayer || [];
    // console.log(default_data);
    window.dataLayer.push(default_data);

    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);
  }, [gtmId, default_data?.Unique_ID]);
}
